import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { ActionTypes } from "../../../OrderFlowProvider/OrderFlowActionTypes";
import { ModuleNames } from "../../../OrderFlowProvider/OrderFlowTypes";
const handleIsSubscriptionChange = (cartIsSubscription, dispatch) => (isSubscription) => {
    if (cartIsSubscription === isSubscription) {
        return;
    }
    dispatch({ type: ActionTypes.SET_IS_SUBSCRIPTION, payload: isSubscription });
    dispatch({ type: ActionTypes.SET_RECIPE_FETCH_STATUS, payload: { completed: false, error: false } });
};
export const useSubscription = (sequenceNumber) => {
    var _a;
    const { store, dispatch } = useOrderFlow();
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((module) => module.ModuleName === ModuleNames.SUBSCRIPTION &&
        module.Sequence === sequenceNumber &&
        module.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    return {
        handleIsSubscriptionChange: handleIsSubscriptionChange(store.cart.isSubscription, dispatch),
        visible: moduleConfig.Visible,
        subscriptionLabelText: moduleConfig.SubscriptionLabelText,
        oneTimeLabelText: moduleConfig.OneTimeLabelText,
        isSubscription: store.cart.isSubscription,
    };
};
